// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import iView from 'iview'
import config from '@/config'
import importDirective from '@/directive'
import { directive as clickOutside } from 'v-click-outside-x'
import installPlugin from '@/plugin'
import '@/assets/icons/iconfont.less'
import ElementUI from 'element-ui'
import './index.less'
import Component from './components'
import AreaComponent from 'element-ui-area'
import 'animate.css'
import api from './api'
import beforeRequest from './libs/before-request'
import ApiCreator from 'vue-api-creator'
import TreeTableComponent from 'element-ui-tree-table'
import 'element-ui-tree-table/dist/index.css'
import Mixins from '@/mixins/common'
import {has} from '@/libs/auth'
import VueCodemirror from 'vue-codemirror'
import {initFilters} from './utils/filters'
import VCharts from 'v-echartsjs'
import defaultThemes from '@/libs/vcharts-theme'
import VueSkeleton from 've-skeleton'
import 've-skeleton/lib/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import '@/assets/element-ui/index.css'
import VueSimpleUEditor from 'vue-simple-ueditor'
import FrameworkComponents from '@fw/install'

// require styles
import 'codemirror/lib/codemirror.css'
const isDev = process.env.NODE_ENV !== 'production'
Vue.use(VueSkeleton)
Vue.use(VueSimpleUEditor)
Vue.mixin(Mixins)
Vue.use(iView)
Vue.use(ElementUI, {
  size: 'small',
  global: {'$--color-primary': '#911B21'}
})
Vue.use(VueCodemirror)
Vue.use(AreaComponent)
Vue.use(Component)
Vue.use(TreeTableComponent, {
  prefix: 'el' // 可选
})
Vue.use(FrameworkComponents, {
  dictApi: 'pub/dict/list',
  upload: {
    action: `/gdjx/file/upload/add`,
    lAction: '/gdjx/file/upload/bigFileUpload',
    data: {
      source: '1'
    }
  }
})

Vue.use(ApiCreator, {
  baseURL: '/gdjx',
  modules: api,
  beforeRequest,
  onError (err) {
    if (err.isInternalError) {
      if (isDev) {
        Vue.prototype.$notify.error({
          title: 'Request Error',
          dangerouslyUseHTMLString: true,
          message: `
            <div>${err.config.desc ? err.config.desc + '：' : ''}${err.msg}</div>
            <div style="color:red;word-break:break-all;">${err.config.url}</div>
          `
        })
      } else {
        Vue.prototype.$Message.error('您的网络出了问题，请稍后重试')
      }
    }
  },
  mock: 'https://www.fastmock.site/mock/99e3783b700ec1a6fd488eee7abec733/gdjx'
})
Vue.use(VCharts, {
  themes: {
    defaultThemes
  },
  theme: 'defaultThemes'
})
/**
 * @description 注册admin内置插件
 */
installPlugin(Vue)
/**
 * @description 生产环境关掉提示
 */
Vue.config.productionTip = false
/**
 * @description 全局注册应用配置
 */
Vue.prototype.$config = config
Vue.prototype.$has = has
/**
 * 注册指令
 */
importDirective(Vue)
Vue.directive('clickOutside', clickOutside)
initFilters(Vue)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js